import React from "react";
import propTypes from "prop-types";
import { IWorkflowToolBoxItem } from "../../../../logic/api";
import { getToolBoxIconByRef } from "./ToolBoxItems";

const ToolBoxItem: React.FunctionComponent<{
    item: IWorkflowToolBoxItem;
    toolBoxItems: IWorkflowToolBoxItem[];
    onItemClicked: (item: IWorkflowToolBoxItem) => void
}> = (props) => {
    const icon = getToolBoxIconByRef(props.toolBoxItems, props.item.ref, 30);

    return <div style={{ display: "inline-block", width: "50%" }}>
        <div style={{
            margin: 5,
            padding: 10,
            border: "solid 1px lightgray",
            textAlign: "center",
            borderRadius: 5,
            cursor: "pointer",
            backgroundColor: "white"
        }}
            onClick={() => {
                props.onItemClicked(props.item);
            }}
        >
            <div style={{ padding: 10 }}>
                {icon}
            </div>
            <div>
                {props.item.name}
            </div>
        </div>
    </div>
}

ToolBoxItem.propTypes = {
    item: propTypes.any.isRequired,
    toolBoxItems: propTypes.any.isRequired,
    onItemClicked: propTypes.func.isRequired
}

export default ToolBoxItem;